const emailActionTypes = {
  GET_EMAIL: 'GET_EMAIL',
  SET_EMAIL: 'SET_EMAIL',
  GET_EMAIL_DETAIL: 'GET_EMAIL_DETAIL',
  SET_EMAIL_DETAIL: 'SET_EMAIL_DETAIL',
  SET_EMAIL_DETAIL_ERROR: 'SET_EMAIL_DETAIL_ERROR',
  DEL_EMAIL: 'DEL_EMAIL',
};

export default emailActionTypes;
